export const Logo = ({ className = "w-9 h-9" }) => (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
        <rect width="48" height="48" rx="10" fill="#0B0C0E" />
        <path d="M10 38V12L24 26L38 12V38" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="24" cy="26" r="3.5" fill="#FFFFFF" />
        <path d="M17 38H31" stroke="#71717A" strokeWidth="3" strokeLinecap="round" />
    </svg>
);
